import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

extend('required', {
  ...rules.required,
  message: '该字段必填'
});

extend('email', {
  ...rules.email,
  message: '请输入正确的邮箱格式'
});